import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import BackButtonSvg from "../../common/BackButtonSvg";

function CustomerLicense() {
  return (
    <div>      
      <div className="wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>Customer License Details</h4>

            <div className="top-btn">
              <Button color="primary">
                 <BackButtonSvg />
                Back</Button>
            </div>
          </div>

          <Card body className="mt-4 license-details">
            <h4 className="text-center mb-5">Park License</h4>

            <h5>License Details</h5>


            <Row>
              <Col md="4">
              <div className="user-box">
                      <img src="https://dummyimage.com/300x300/c0d2ed/7c7c85.png&text=Profile+pic" alt=""/>
                      <p>Dog Profile</p>

                      <div className="upload-btn-wrapper">
  <button className="upload-btn"><svg xmlns="http://www.w3.org/2000/svg" width="19.407" height="16.981" viewBox="0 0 19.407 16.981">
  <path id="Icon_awesome-camera" data-name="Icon awesome-camera" d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z" transform="translate(0 -2.25)" fill="#d51d1d"/>
</svg>
</button>
  <input type="file" name="myfile" />
</div>


                    </div>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label for="">Pet Name</Label>
                  <Input type="text" name="" id="" placeholder="placeHolder" />
                </FormGroup>
                <FormGroup>
                  <Label for="">Color</Label>
                  <Input type="text" name="" id="" placeholder="placeHolder" />
                </FormGroup>
                <FormGroup>
                  <Label for="">Age</Label>
                  <Input type="text" name="" id="" placeholder="placeHolder" />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label for="">Breed</Label>
                  <Input type="text" name="" id="" placeholder="placeHolder" />
                </FormGroup>
                <FormGroup>
                  <Label for="">DOB</Label>
                  <Input type="date" name="" id="" placeholder="placeHolder" />
                </FormGroup>
                <FormGroup>
                  <Label for="">Description</Label>
                  <Input type="text" name="" id="" placeholder="placeHolder" />
                </FormGroup>
              </Col>
            </Row>
            <h5  className="mt-5">Additional Document</h5>
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label for="">Rabies Vaccination Certificate</Label>

                  <div className="file-upload-btn-wrapper">
  <button className="file-upload-btn"><svg xmlns="http://www.w3.org/2000/svg" width="19.945" height="19.945" viewBox="0 0 19.945 19.945">
  <g id="Icon_feather-upload" data-name="Icon feather-upload" transform="translate(1 1)">
    <path id="Path_36" data-name="Path 36" d="M22.445,22.5v3.988a1.994,1.994,0,0,1-1.994,1.994H6.494A1.994,1.994,0,0,1,4.5,26.488V22.5" transform="translate(-4.5 -10.537)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="Path_37" data-name="Path 37" d="M20.469,9.485,15.485,4.5,10.5,9.485" transform="translate(-6.512 -4.5)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="Path_38" data-name="Path 38" d="M18,4.5V16.463" transform="translate(-9.028 -4.5)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>
  Upload a file</button>
  <input type="file" name="myfile" />
</div>


<div className="upload-list">
  <div className="list">
<svg viewBox="64 64 896 896" focusable="false" data-icon="paper-clip" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                    <path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path>
</svg><p>placeholder.PDF</p></div>
</div>






                </FormGroup>
              </Col>
              <Col md="4">
              <Label for="">Leptospirosis Vaccination Certficate</Label>
              <div className="file-upload-btn-wrapper">
  <button className="file-upload-btn"><svg xmlns="http://www.w3.org/2000/svg" width="19.945" height="19.945" viewBox="0 0 19.945 19.945">
  <g id="Icon_feather-upload" data-name="Icon feather-upload" transform="translate(1 1)">
    <path id="Path_36" data-name="Path 36" d="M22.445,22.5v3.988a1.994,1.994,0,0,1-1.994,1.994H6.494A1.994,1.994,0,0,1,4.5,26.488V22.5" transform="translate(-4.5 -10.537)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="Path_37" data-name="Path 37" d="M20.469,9.485,15.485,4.5,10.5,9.485" transform="translate(-6.512 -4.5)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="Path_38" data-name="Path 38" d="M18,4.5V16.463" transform="translate(-9.028 -4.5)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>
  Upload a file</button>
  <input type="file" name="myfile" />
</div>

<div className="upload-list">
  <div className="list">
<svg viewBox="64 64 896 896" focusable="false" data-icon="paper-clip" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                    <path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path>
</svg><p>placeholder.PDF</p></div>
</div>

              </Col>
              <Col md="4">
              <Label for="">Dog's Owner Address Proof</Label>
              <div className="file-upload-btn-wrapper">
  <button className="file-upload-btn"><svg xmlns="http://www.w3.org/2000/svg" width="19.945" height="19.945" viewBox="0 0 19.945 19.945">
  <g id="Icon_feather-upload" data-name="Icon feather-upload" transform="translate(1 1)">
    <path id="Path_36" data-name="Path 36" d="M22.445,22.5v3.988a1.994,1.994,0,0,1-1.994,1.994H6.494A1.994,1.994,0,0,1,4.5,26.488V22.5" transform="translate(-4.5 -10.537)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="Path_37" data-name="Path 37" d="M20.469,9.485,15.485,4.5,10.5,9.485" transform="translate(-6.512 -4.5)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="Path_38" data-name="Path 38" d="M18,4.5V16.463" transform="translate(-9.028 -4.5)" fill="none" stroke="#1b3e6f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>
  Upload a file</button>
  <input type="file" name="myfile" />
</div>
<div className="upload-list">
  <div className="list">
<svg viewBox="64 64 896 896" focusable="false" data-icon="paper-clip" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                    <path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path>
</svg><p>placeholder.PDF</p></div>
</div>


              </Col>
            </Row>

            <h5 className="mt-5">Plan Details</h5>

<Row className="plan-list">
  <Col md="4">


  <div className="box">
<h4>Base</h4>
<h1><strong>$</strong>102<span>/12 month</span></h1>
<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
    
    <ul>
        <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="17.011" height="17.011" viewBox="0 0 17.011 17.011">
  <path id="Icon_material-check-box" data-name="Icon material-check-box" d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z" transform="translate(-4.5 -4.5)" fill="#fff"/>
</svg>
 Park License</li>
        <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="17.011" height="17.011" viewBox="0 0 17.011 17.011">
  <path id="Icon_material-check-box" data-name="Icon material-check-box" d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z" transform="translate(-4.5 -4.5)" fill="#fff"/>
</svg>
 Kennel License</li>
    </ul>
    
    
        </div>
   

  </Col>
</Row>

          </Card>
        </Container>
      </div>
    </div>
  );
}

export default CustomerLicense;
